import React from 'react';
import styled from 'styled-components';
import { Icon } from 'components/Icon';
import { toRem } from 'design';
import { IntegrationType } from 'types';

interface IIntegrationLogoProps {
  type?: IntegrationType;
}

const Wrapper = styled.div`
  margin: ${toRem(8)};
`;

const IntegrationLogo: React.FC<IIntegrationLogoProps> = ({ type }: IIntegrationLogoProps) => {
  if (type.toLowerCase() === IntegrationType.ADORA) {
    return (
      <Wrapper>
        <Icon icon="Adora" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.ALOHA) {
    return (
      <Wrapper>
        <Icon icon="Aloha" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.BRINK) {
    return (
      <Wrapper>
        <Icon icon="Brink" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.HEARTLAND) {
    return (
      <Wrapper>
        <Icon icon="Heartland" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.ORACLE) {
    return (
      <Wrapper>
        <Icon icon="Oracle" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.RPOWER) {
    return (
      <Wrapper>
        <Icon icon="RPower" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.SHIFT4) {
    return (
      <Wrapper>
        <Icon icon="Shift4" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.SQUARE) {
    return (
      <Wrapper>
        <Icon icon="SquareLogo" width={88} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.TOAST) {
    return (
      <Wrapper>
        <Icon icon="Toast" width={120} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.UNION) {
    return (
      <Wrapper>
        <Icon icon="UnionPOS" width={120} />
      </Wrapper>
    );
  }

  if (type.toLowerCase() === IntegrationType.KICKFIN) {
    return (
      <Wrapper>
        <Icon icon="LogoMark" width={120} />
      </Wrapper>
    );
  }

  return null;
};

export default IntegrationLogo;
